import { render, staticRenderFns } from "./Web_taiyakan.vue?vue&type=template&id=5fd99dbc&scoped=true&"
import script from "./Web_taiyakan.vue?vue&type=script&lang=js&"
export * from "./Web_taiyakan.vue?vue&type=script&lang=js&"
import style0 from "./Web_taiyakan.vue?vue&type=style&index=0&id=5fd99dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd99dbc",
  null
  
)

export default component.exports